import SceneCard from '@/components/app/scenes/SceneCard';

import { Wrapper } from './styles';
import { SceneCardGridProps } from './types';

const SceneCardGrid = ({ scenes, selectedScene }: SceneCardGridProps) => {
	return (
		<Wrapper>
			{scenes.map(scene => (
				<SceneCard key={scene.id} card={scene} isSelected={scene.id === selectedScene?.id} />
			))}
		</Wrapper>
	);
};

export default SceneCardGrid;
